import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="mx-auto max-w-4xl text-center">
          <h2 className="font-heading text-2xl md:text-4xl lg:text-5xl font-bold text-foreground-950 leading-tight">
            准备好开始你的
            <br />
            韩漫之旅了吗？
          </h2>
          <p className="mt-4 text-foreground-500 text-sm md:text-base max-w-lg mx-auto">
            数千部优质韩漫等你来发现，完全免费，即刻开启阅读
          </p>
          <Link
            to="/category"
            className="mt-8 inline-flex items-center gap-2 px-8 py-3.5 bg-primary-500 hover:bg-primary-600 text-background-50 font-medium text-sm rounded-full transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            开始探索 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="mt-12 overflow-hidden">
          <div className="flex gap-4 animate-scroll">
            {[
              'https://readdy.ai/api/search-image?query=Korean%20webtoon%20character%20illustration%20young%20woman%20beautiful%20portrait%20soft%20colors%20manhwa%20art%20style%20clean%20white%20background%20professional%20digital%20painting&width=200&height=280&seq=cta-strip-01&orientation=portrait',
              'https://readdy.ai/api/search-image?query=Korean%20webtoon%20character%20illustration%20handsome%20man%20fantasy%20warrior%20outfit%20manhwa%20art%20style%20clean%20white%20background%20professional%20digital%20painting%20soft%20colors&width=200&height=280&seq=cta-strip-02&orientation=portrait',
              'https://readdy.ai/api/search-image?query=Korean%20webtoon%20character%20illustration%20schoolgirl%20uniform%20cute%20smile%20manhwa%20art%20style%20clean%20white%20background%20professional%20digital%20painting%20soft%20pastel%20colors&width=200&height=280&seq=cta-strip-03&orientation=portrait',
              'https://readdy.ai/api/search-image?query=Korean%20webtoon%20character%20illustration%20mysterious%20detective%20man%20in%20coat%20manhwa%20art%20style%20clean%20white%20background%20professional%20digital%20painting%20moody%20atmosphere&width=200&height=280&seq=cta-strip-04&orientation=portrait',
              'https://readdy.ai/api/search-image?query=Korean%20webtoon%20character%20illustration%20noble%20lady%20historical%20hanbok%20dress%20beautiful%20manhwa%20art%20style%20clean%20white%20background%20professional%20digital%20painting%20elegant&width=200&height=280&seq=cta-strip-05&orientation=portrait',
              'https://readdy.ai/api/search-image?query=Korean%20webtoon%20character%20illustration%20cat%20ears%20girl%20cute%20fantasy%20manhwa%20art%20style%20clean%20white%20background%20professional%20digital%20painting%20soft%20colors&width=200&height=280&seq=cta-strip-06&orientation=portrait',
              'https://readdy.ai/api/search-image?query=Korean%20webtoon%20character%20illustration%20chef%20young%20man%20holding%20food%20manhwa%20art%20style%20clean%20white%20background%20professional%20digital%20painting%20warm%20colors&width=200&height=280&seq=cta-strip-07&orientation=portrait',
            ].map((img, idx) => (
              <div
                key={idx}
                className="flex-shrink-0 w-28 md:w-36 h-40 md:h-48 rounded-xl overflow-hidden bg-background-100"
              >
                <img
                  src={img}
                  alt=""
                  className="w-full h-full object-cover object-top"
                  loading="lazy"
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}